import { observable } from "mobx"
import AtualizacaoCadastralService from "../../../services/AtualizacaoCadastralService"
import FileSaver from 'file-saver'
import {toast} from "react-toastify";
import { sortCaret } from '../../comum/components/Icones';
import { formatarDataCustomHTML, statusNotaFormatter } from '../../../utils/formatar';

export default class EmailFaturamentoStore {

    @observable grupoEmail;

    @observable listaClientes;
    @observable listaCategorias;

    @observable abaAtiva;

    @observable clienteSelecionado;
    @observable clienteCarregado;
    @observable clientIdSelecionado
    @observable categoriaSelecionado;
    @observable emailSelecionado;
    @observable novoEmail;
    @observable listaEmail;
    @observable listaEmailsFormatado;
    @observable validateEmailMessage;
    @observable novoEmailValido;

    @observable filtroGrupoEmailId;

    @observable mostrarModalNovoEmail;
    @observable mostrarModalEditarEmail;
    @observable mostrarModalSucesso;
    @observable mostrarModalFalha;
    @observable mostrarModalConfirmacao;
    @observable mostrarModalSelecaoRadical
    @observable mostrarModalConfirm;

    @observable cnpjsPertentencesMesmoRadical;

    @observable modalMensagem;

    @observable loadingRelatorio;
    @observable loadingClientes;
    @observable loadingCnpjsMesmoRadical;
    @observable loadingAplicandoSalvarEmail;
    @observable loadingAplicandoExcluirEmail;
    @observable textoFiltroCliente;

    @observable filtrado;
    @observable aplicarMesmoRadical;

    constructor() {

        this.clienteSelecionado = null;
        this.clienteCarregado = "Nenhum cliente carregado";
        this.clientIdSelecionado = null;
        this.categoriaSelecionado = null;
        this.emailSelecionado = {
            Id: 0,
            GrupoemailId: 0,
            TipoInterfaceId: '35',
            Email: '',
            EmailTipo: 'DES'
        };

        this.novoEmail = {
            Id: 0,
            GrupoemailId: 0,
            TipoInterfaceId: '35',
            Email: '',
            EmailTipo: 'DES'
        };
        this.modalMensagem = '';
        this.filtroGrupoEmailId = 0;
        this.listaEmail = [];
        this.listaEmailsFormatado = [];
        this.validateEmailMessage = ""
        this.novoEmailValido = false;

        this.grupoEmail = []
        this.listaClientes = []
        this.listaCategorias = []
        this.cnpjsPertentencesMesmoRadical = []
        this.abaAtiva = "email"
        this.loadingRelatorio = false
        this.loadingClientes = false;
        this.loadingCnpjsMesmoRadical = false;
        this.loadingAplicandoSalvarEmail = false;
        this.loadingAplicandoExcluirEmail = false;
        this.filtrado = false;
        this.mostrarModalNovoEmail = false;
        this.mostrarModalEditarEmail = false
        this.mostrarModalSucesso = false;
        this.mostrarModalFalha = false;
        this.mostrarModalConfirmacao = false;
        this.mostrarModalSelecaoRadical = false;
        this.mostrarModalConfirm = false;
        this.aplicarMesmoRadical = false;
        this.textoFiltroCliente = "";
        this.service = new AtualizacaoCadastralService()

        //this.listarClientes()
        this.listarCategorias()

        /** Colunas da Tabela */
        this.colunas = [{
            dataField: 'Email',
            text: 'Email',
            sort: true,
            sortCaret: sortCaret,
        }
        ];
    }
    setCliente = (event) => {
        this.clienteSelecionado = event
    }

    setClienteCarregado = (event) => {

        this.ClienteCarregado = event
    }

    setTextoFiltroCliente = (event) => {
        this.textoFiltroCliente = event.target.value;
    }

    setCategoria = (event) => {
        this.categoriaSelecionado = event;
    }

    setNovoEmail = (event) => {
        this.novoEmail.Email = event.target.value;
        this.novoEmail.Email = this.novoEmail.Email.replaceAll(" ", "");
    }

    validateValidEmail = (email) => {
        return String(email)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            ) !== null;
    };
    emailAlreadyExistsOnNewEmailList = (email) => {
        return this.listaEmail.includes(email.toLowerCase());
    };
    emailAlreadyRegisteredOnGroupEmail = (email) => {
        var alreadyRegistered = false
        this.grupoEmail.map(x => {
            if (x.Email == email.toLowerCase()) {
                alreadyRegistered = true;
            }
        });
        return alreadyRegistered;
    };

    fecharTodosModais = () => {
        this.mostrarModalEditarEmail = false;
        this.mostrarModalNovoEmail = false;
        this.mostrarModalSucesso = false;
        this.mostrarModalFalha = false;
        this.mostrarModalConfirmacao = false;
        this.mostrarModalSelecaoRadical = false;
        this.mostrarModalConfirm = false;
        this.pesquisar2(this.clienteSelecionado, this.categoriaSelecionado, this.clienteSelecionado.clientId,this.clienteSelecionado);
    }

    listarClientes = () => {
        
        this.loadingClientes = true;
        this.setCliente(null);
        this.service.ListarClientes(this.textoFiltroCliente).then(response => {
            if (response && response.data && response.data.length > 0) {
                toast.success(`Encontrado ${response.data.length} registros para o filtro selecionado`);
                this.listaClientes = response.data.map(cliente => ({ label: cliente.Razao, value: cliente.ClientId, parId: cliente.ParId, clientId: cliente.ClientId, cnpj: cliente.Cnpj }))
            }
            else{
                this.listaClientes = []
                toast.error("Não foi encontrado Clientes com o filtro selecionado");
            }
        }).catch(err => console.error(err)).finally(() =>this.loadingClientes = false)
    }


    listarCnpjsPertentencesMesmoRadical = (cnpj) => {
        this.loadingCnpjsMesmoRadical = true;
        this.service.ListarCnpjsPertentencesMesmoRadical(cnpj).then(response => {
            if (response && response.data && response.data.length > 0) {

                this.cnpjsPertentencesMesmoRadical = response.data.map(cnpj => ({
                    ClientId: cnpj.ClientId,
                    Cnpj: cnpj.Cnpj,
                    Membershipuserid: cnpj.Membershipuserid,
                    ParId: cnpj.ParId,
                    Razao: cnpj.Razao
                }));
            }
        }).catch(err => console.error(err)).finally(() => this.loadingCnpjsMesmoRadical = false)
    }

    listarCategorias = () => {
        this.service.ListarCategorias().then(response => {
            if (response && response.data && response.data.length > 0) {
                this.listaCategorias = response.data.map(categoria => ({ label: categoria.Codigo, value: categoria.Descricao }))
            }
        }).catch(err => console.error("ERRO LISTAR CATEGORIA " + err))
    }

    mudarAba = (aba) => {
        this.abaAtiva = aba;
    }

    CadastrarListaEmails = (listaEmails, radical) => {
        this.loadingAplicandoSalvarEmail = true;
        this.listaEmailsFormatado = []
        listaEmails.map(email => {
            this.listaEmailsFormatado.push({
                Id: 0,
                GrupoemailId: this.filtroGrupoEmailId,
                TipoInterfaceId: "35",
                Email: email,
                EmailTipo: "DES"
            })
        })
        this.service.AdicionarEmail(this.listaEmailsFormatado, radical, this.cnpjsPertentencesMesmoRadical).then(response => {

            //this.fecharTodosModais();
            if (response.status == 200) {
                if (radical)
                    this.modalMensagem = 'email cadastrado e replicado ao radical';
                else {
                    this.modalMensagem = 'email cadastrado';
                }
                this.mostrarModalSucesso = true;
                this.listaEmail = [];
                this.novoEmail.Email = '';
                this.validateEmailMessage = "";
            }
            else {
                if (response.status = 500) {
                    this.modalMensagem = response.data.ExceptionMessage == null ? response.data : response.data.ExceptionMessage;
                }
                else {
                    this.modalMensagem = response.data;
                }


                this.mostrarModalFalha = true;

            }
            this.listaEmailsFormatado = [];
        }).catch(err => {
            console.error("ERRO CadastrarNovoEmail " + err)
            this.modalMensagem = err;

            this.mostrarModalFalha = true;
            this.listaEmailsFormatado = [];
        }).finally(() => this.loadingAplicandoSalvarEmail = false)
    }

    ExcluirEmail = (email, radical) => {
        this.loadingAplicandoExcluirEmail = true;
        this.service.RemoverEmail(email, radical, this.cnpjsPertentencesMesmoRadical).then(response => {
            this.fecharTodosModais();
            if (response.status == 204) {
                if (radical) {
                    this.modalMensagem = 'email excluido e replicado ao radical'
                }
                else {
                    this.modalMensagem = 'email excluido com sucesso'
                }


                this.mostrarModalSucesso = true;
            }
            else {
                this.modalMensagem = response.data;

                this.mostrarModalFalha = true;
            }

        }).catch(err => {
            console.error("ERRO ExcluirEmail " + err)
            this.modalMensagem = err;

            this.mostrarModalFalha = true;
        }).finally(() => this.loadingAplicandoExcluirEmail = false)
    }

    pesquisar2 = (partnerId = "", categoriaId = "", clientId = "",clientobject) => {
        this.clientIdSelecionado = clientId;
        this.loadingRelatorio = true;
        if (this.clienteSelecionado === null || this.categoriaSelecionado === null) {
            this.loadingRelatorio = false;
            this.grupoEmail = [];
            this.filtrado = false;
            return;
        }
        this.grupoEmail = [];
        this.clienteCarregado = ""
        this.filtrado = true;
        this.service.ListarGrupoEmail(partnerId.parId, categoriaId.label, this.clientIdSelecionado).then(response => {
            if (response.data === null) {
                return
            }
            this.grupoEmail = response.data;
            this.clienteCarregado = `Cliente carregado : ${clientobject.label}`;
            
            this.service.ListarGrupoEmailId(partnerId.parId, categoriaId.label, this.clientIdSelecionado).then(response => {

                if (response.data === null) {
                    return
                }
                this.filtroGrupoEmailId = response.data;

            })
        }).catch(err => console.error(err)).finally(() => this.loadingRelatorio = false)
    }

    arrayRemove = (arr, value) => {

        return arr.filter(function (ele) {
            return ele != value;
        });
    }
}



// WEBPACK FOOTER //
// ./src/modules/atualizacaocadastral/stores/EmailFaturamentoStore.js